module.exports = __webpack_public_path__ + "static/StellarLogoWhite-700d8ba3fbb62b664bcc6a8e41b27e3c.svg";